/**
 * Returns copy of the provided object with the specified property JSON.parse'd
 */
export function ParseJSONPropertyInObject(property: string, object: object) {
  return {
    ...object,
    [property]: JSON.parse(object[property]),
  }
}
